'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ipConverter = exports.ipConverter = {
  toInt: function toInt(ip) {
    var ipl = 0;
    ip.split('.').forEach(function (octet) {
      ipl <<= 8;
      ipl += parseInt(octet);
    });
    return ipl >>> 0;
  },
  toIp: function toIp(int) {
    return (int >>> 24) + '.' + (int >> 16 & 255) + '.' + (int >> 8 & 255) + '.' + (int & 255);
  }
};

var macConverter = exports.macConverter = {
  toInt: function toInt(mac) {
    return parseInt(mac.replace(/:/g, ''), 16);
  },
  toMac: function toMac(int) {
    return int;
  } };


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/converters.js
 ** module id = 510
 ** module chunks = 0
 **/